import React from 'react';
import { DateWrapper } from '@trucktrax/trucktrax-common';
import { getMixDesignItem } from '@trucktrax/trucktrax-ts-common';
import { RowInfo } from './ticketListConfigurations.types';
import styles from '../TicketList.module.css';
import voidedTicket from '../../../../assets/img/voidedTicket.png';

// NOTE (clogan review, DEV-4153): keep this module a pure leaf — no component
// imports. The Received column (a connected component) lives beside its cell
// in geotrax/incomingMaterials/MaterialReceivedCell.tsx; importing it here
// closed an import cycle back to Main through every config.

export const voidedAccessor = (isVoided?: boolean, content?: any) => {
  if (!isVoided) {
    return `${content}`;
  }

  return <div className={styles.voidedCellStyle}>{`${content}`}</div>;
};

export const ticketNumberAccessor = (row: RowInfo) => (
  <div className={row.voided ? styles.voidedCellStyle : undefined}>
    {`${row.ticketNumber}`}
    {row.voided && <img src={voidedTicket} alt="voided" />}
  </div>
);

export const ticketedTimestampAccessor = (row: RowInfo) => {
  const date = new DateWrapper(row.ticketedTimestamp).toUSDateString();
  return voidedAccessor(row?.voided, date);
};

export const truckAliasAccessor = (row: RowInfo) =>
  voidedAccessor(row?.voided, row.externalInfo?.truckAlias ?? '');

export const driverNameAccessor = (row: RowInfo) =>
  voidedAccessor(row?.voided, row?.externalInfo?.driverName ?? '');

export const customerAccessor = (row: RowInfo) =>
  voidedAccessor(row?.voided, row?.order?.customerName ?? '');

export const orderNumberAccessor = (row: RowInfo) =>
  voidedAccessor(row?.voided, row?.order?.orderNumber ?? 0);

export const addressAccessor = (row: RowInfo) => voidedAccessor(row?.voided, row.address ?? '');

export const loadingPlantAccessor = (row: RowInfo) =>
  voidedAccessor(row?.voided, row.externalInfo?.plantName ?? '');

export const mixDesignProductNumberAccessor = (row: RowInfo) =>
  voidedAccessor(row?.voided, getMixDesignItem(row)?.productNumber ?? '');
